<div class="date-range-selector-container">
  <!-- Calendar View -->
  <div class="calendar-container">
    <!-- Left Calendar -->
    <div class="calendar-month">
      <div class="calendar-header">
        <button class="nav-button" (click)="previousLeftMonth()">
          <span class="material-icons">chevron_left</span>
        </button>
        <span class="month-title">{{ leftMonth | date:'MMMM' }}</span>
        <button class="nav-button" (click)="nextLeftMonth()">
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
      <div class="calendar-weekdays">
        <div class="weekday">Su</div>
        <div class="weekday">Mo</div>
        <div class="weekday">Tu</div>
        <div class="weekday">We</div>
        <div class="weekday">Th</div>
        <div class="weekday">Fr</div>
        <div class="weekday">Sa</div>
      </div>
      <div class="calendar-days">
        <ng-container *ngFor="let day of getDaysForMonth(leftMonth)">
          <div [ngClass]="{
          'calendar-day': true,
          'inactive': !day.isCurrentMonth,
          'selected': isStartDate(day.date) || isEndDate(day.date),
          'in-range': isDateInRange(day.date) && !isStartDate(day.date) && !isEndDate(day.date)
        }">
           <button
              class="day-button"
              type="button"
              [disabled]="!day.isCurrentMonth"
              (click)="$event.stopPropagation(); $event.preventDefault(); onDateClick(day.date)">
              {{ day.day }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Right Calendar -->
    <div class="calendar-month">
      <div class="calendar-header">
        <button class="nav-button" (click)="previousRightMonth()">
          <span class="material-icons">chevron_left</span>
        </button>
        <span class="month-title">{{ rightMonth | date:'MMMM' }}</span>
        <button class="nav-button" (click)="nextRightMonth()">
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
      <div class="calendar-weekdays">
        <div class="weekday">Su</div>
        <div class="weekday">Mo</div>
        <div class="weekday">Tu</div>
        <div class="weekday">We</div>
        <div class="weekday">Th</div>
        <div class="weekday">Fr</div>
        <div class="weekday">Sa</div>
      </div>
      <div class="calendar-days">
        <ng-container *ngFor="let day of getDaysForMonth(rightMonth)">
          <div [ngClass]="{
          'calendar-day': true,
          'inactive': !day.isCurrentMonth,
          'selected': isStartDate(day.date) || isEndDate(day.date),
          'in-range': isDateInRange(day.date) && !isStartDate(day.date) && !isEndDate(day.date)
        }">
            <button
              class="day-button"
              type="button"
              [disabled]="!day.isCurrentMonth"
              (click)="day.isCurrentMonth ? onDateClick(day.date) : null">
              {{ day.day }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="date-selection">
    <div class="selected-range">
      {{ selectedStartDate ? formatDate(selectedStartDate) : '' }}
      <span *ngIf="selectedStartDate && selectedEndDate">—</span>
      {{ selectedEndDate ? formatDate(selectedEndDate) : '' }}
    </div>
    <div class="action-buttons">
      <button class="cancel-button" (click)="cancelSelection()">Cancel</button>
      <button class="apply-button" (click)="applySelection()">Apply</button>
    </div>
  </div>
</div>

<!--============================= to use it use the following code =========================-->
<!--         <button mat-button (click)="openDateRangeDialog()">Select Date Range</button>-->
<!--         <mat-form-field appearance="outline" class="full-width">-->
<!--           <mat-icon matPrefix>event</mat-icon>-->
<!--           <input matInput readonly-->
<!--                  [placeholder]="'Select date range'"-->
<!--                  [value]="dateRange.get('dateFrom')?.value | date:'MMM d, y' : '' + ' - ' + dateRange.get('dateTo')?.value | date:'MMM d, y' : ''"-->
<!--                  (click)="toggleDateRangePicker(i)">-->
<!--         </mat-form-field>-->

<!--         <div *ngIf="showDateRangePicker[i]" class="date-picker-popup">-->
<!--           <app-date-range-selector-->
<!--             [minDate]="minDate"-->
<!--             [maxDate]="maxDate"-->
<!--             [value]="{ start: dateRange.get('dateFrom')?.value, end: dateRange.get('dateTo')?.value }"-->
<!--             (dateRangeSelected)="onDateRangeSelected($event, i)">-->
<!--           </app-date-range-selector>-->
<!--         </div>-->
<!--============================= to use it use the following code =========================-->
